module.exports = __webpack_public_path__ + "img/qilin-stage1-hungry.ac42beea.png";